import { render, staticRenderFns } from "./tableBook.vue?vue&type=template&id=33d679b0&"
import script from "./tableBook.vue?vue&type=script&lang=js&"
export * from "./tableBook.vue?vue&type=script&lang=js&"
import style0 from "./tableBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports